import { FunctionComponent } from 'react';
import { getCssVar } from '../../../utils';
import { IconLabel, IconLabelHintDirection } from '../../IconLabel';

import classes from './BlockToolLabel.module.scss';

interface BlockToolLabelProps {
  iconId: string;
  hint: string;
  active: boolean;
  onMouseDown: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disabled?: boolean;
}

export const BlockToolLabel: FunctionComponent<BlockToolLabelProps> = ({
  iconId,
  hint,
  active,
  onMouseDown,
  disabled,
}) => {
  const prefix = '--icon-label-with-active';
  const text = `${prefix}-text-color`;
  const textActive = `${prefix}-text-active-color`;
  const background = `${prefix}-background-active-color`;

  return (
    <IconLabel
      className={classes['label']}
      iconId={iconId}
      iconSize={20}
      data={hint}
      hintDirection={IconLabelHintDirection.top}
      onMouseDown={onMouseDown}
      color={getCssVar(active ? textActive : text)}
      hoverColor={getCssVar(textActive)}
      backgroundColor={getCssVar(active ? background : '')}
      disabled={disabled}
      withPadding
    />
  );
};
